class PyramidPointRenderer {
  constructor(pointSize) {
    this.pointSize = pointSize;
    this.pointBufferMap = {};
  }

  renderPoint(context, color, offset) {
    let bufferCanvas = this._ensureBufferedPointForColor(color);
    context.drawImage(bufferCanvas, offset.x, offset.y);
  }

  _ensureBufferedPointForColor(color) {
    let colorHexString = color.hexString();
    let canvas = this.pointBufferMap[colorHexString];

    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.width = this.pointSize;
      canvas.height = this.pointSize;

      this._drawPointInBuffer(color, canvas);
      this.pointBufferMap[colorHexString] = canvas;
    }

    return canvas;
  }

  _drawPointInBuffer(color, canvas) {

    let context = canvas.getContext("2d");
    let offset = { x: 0, y: 0 };

    context.fillStyle = color.hexString();
    context.fillRect(offset.x, offset.y, this.pointSize, this.pointSize);

    let center = { x: offset.x + (this.pointSize / 2), y: offset.y + (this.pointSize / 2) };

    // top slope
    context.beginPath();
    context.moveTo(center.x, center.y);
    context.lineTo(offset.x, offset.y);
    context.lineTo(offset.x + this.pointSize, offset.y);
    context.closePath();
    context.fillStyle = color.clone().lighten(0.4).hexString();
    context.fill();

    // right slope
    context.beginPath();
    context.moveTo(center.x, center.y);
    context.lineTo(offset.x + this.pointSize, offset.y);
    context.lineTo(offset.x + this.pointSize, offset.y + this.pointSize);
    context.closePath();
    context.fillStyle = color.clone().lighten(0.6).hexString();
    context.fill();

    // bottom slope
    context.beginPath();
    context.moveTo(center.x, center.y);
    context.lineTo(offset.x + this.pointSize, offset.y + this.pointSize);
    context.lineTo(offset.x, offset.y + this.pointSize);
    context.closePath();
    context.fillStyle = color.clone().lighten(0.2).hexString();
    context.fill();
  }
}

export default PyramidPointRenderer;



// WEBPACK FOOTER //
// ./src/visuals/point-rendering/PyramidPointRenderer.js